import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { IdentificationSection } from '../components/IdentificationSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhyNothingWorksSection } from '../components/WhyNothingWorksSection';
import { MethodSection } from '../components/MethodSection';
import { WhatChangesSection } from '../components/WhatChangesSection';
import { EmpiezaSection } from '../components/EmpiezaSection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { FinalOfferSection } from '../components/FinalOfferSection';
export function LandingPage() {
  return <main className="w-full" data-id="element-286">
      <HeroSection data-id="element-287" />

      <IdentificationSection data-id="element-288" />
      <MechanismSection data-id="element-289" />
      <WhyNothingWorksSection data-id="element-290" />
      <MethodSection data-id="element-291" />
      <WhatChangesSection data-id="element-292" />
      <EmpiezaSection data-id="element-293" />
      <ObjectionsSection data-id="element-294" />
      <FinalOfferSection data-id="element-295" />
    </main>;
}